import { render, staticRenderFns } from "./AnimatedTabs.vue?vue&type=template&id=459d0761&scoped=true&"
import script from "./AnimatedTabs.vue?vue&type=script&lang=js&"
export * from "./AnimatedTabs.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedTabs.vue?vue&type=style&index=0&id=459d0761&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d0761",
  null
  
)

export default component.exports